export default "__VITE_ASSET__zo9uHSvu__"